import React from 'react'
import { Table, Spinner } from 'react-bootstrap'
import './kycStyle.css'
import { Person } from '../../screens/CreditReportById/CreditReportById'
import '../../components/kyc/SearchResultsTable.css'

type SearchResultTableProps = {
  showProgress: boolean
  handleLoadCreditReport: (person: any) => void
  results: Person[]
}
export const CreditReportResultTable: React.FC<SearchResultTableProps> = ({
  showProgress,
  handleLoadCreditReport,
  results,
}) => {
  return (
    <div
      className="kyc-results-table-container"
      style={{ height: '300px', overflow: '20' }}
    >
      <table>
        <thead>
          <tr>
            <td
              style={{
                backgroundColor: 'rgb(12, 135, 169)',
                color: 'rgb(255, 255, 255)',
                // position: 'sticky',
                // top: 0,
                width: '50%',
              }}
            >
              RSA ID / Passport #
            </td>
            <td
              style={{
                backgroundColor: 'rgb(12, 135, 169)',
                color: 'rgb(255, 255, 255)',
                // position: 'sticky',
                // top: 0,
              }}
            >
              Name
            </td>
          </tr>
        </thead>
        <tbody>
          {results.map((person) => {
            return (
              <tr
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  handleLoadCreditReport(person)
                }}
              >
                <td>{person.idno ? person.idno : person.passportnumber}</td>
                <td>{person.firstname + ' ' + person.surname}</td>
              </tr>
            )
          })}
        </tbody>
      </table>
      {showProgress && (
        <>
          <div className="spinner-container">
            <Spinner
              as="span"
              animation="border"
              variant="dark"
              role="status"
              aria-hidden="true"
            ></Spinner>
            <span> </span>
          </div>
        </>
      )}
    </div>
  )
}

export default CreditReportResultTable
